import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useGeneralStore = defineStore('general', () => {
    const coinCurrencySelect = ref('Currency');
    const showingToast = ref(false);
    const displayToast = ref(false);
    const hideToast = ref(false);
    const toastMessage = ref('');
    const widgetFlowsEnabled = ref([]);
    const showToast = (message) => {
        toastMessage.value = message;
        displayToast.value = true;
        hideToast.value = false;
        showingToast.value = true;
        setTimeout(() => {
            displayToast.value = false;
            hideToast.value = true;
            setTimeout(() => {
                toastMessage.value = '';
                showingToast.value = false;
            }, 500);
        }, 3000);
    };
    return {
        coinCurrencySelect,
        showingToast,
        toastMessage,
        showToast,
        displayToast,
        hideToast,
        widgetFlowsEnabled,
    };
});
export default useGeneralStore;
